// Shared layout-related constants used by measuring and layout engine

// Spacing between list marker text and list item text, in px
export const LIST_MARKER_GAP = 8;

// Minimum width reserved for the list marker gutter, in px
export const MIN_MARKER_GUTTER = 24;

// Default list indentation parameters (in px)
export const DEFAULT_LIST_INDENT_BASE_PX = 24;
export const DEFAULT_LIST_INDENT_STEP_PX = 24;
export const DEFAULT_LIST_HANGING_PX = 18;

// Gap in pixels added after list marker when suffix is 'space'
export const SPACE_SUFFIX_GAP_PX = 4;

// Default tab interval in pixels (0.5 inches at 96 DPI)
export const DEFAULT_TAB_INTERVAL_PX = 48;
